__turbopack_context__.v({
  "icon": "_5VMFCG_icon",
  "message": "_5VMFCG_message",
});
